import reducer from "./reducers";
export { default as flightActions } from "./actions";

export default reducer;